export enum ModuleStatusEnum {
  NOTSTARTED = 'NOTSTARTED',
  INPROGRESS = 'INPROGRESS',
  COMPLETED = 'COMPLETED',
}
